export default {
  title: 'Zamów fakturę',
  form: {
    is_receipt_required: {
      label: 'Zamów fakturę e-mailem',
    },
    company_name: {
      placeholder: 'Nazwa firmy (opcjonalnie)',
    },
    first_name: {
      placeholder: 'Imię',
    },
    last_name: {
      placeholder: 'Nazwisko',
    },
    address: {
      placeholder: 'Ulica i numer',
    },
    zip_code: {
      placeholder: 'Kod pocztowy',
    },
    city: {
      placeholder: 'Miasto',
    },
    tax_id: {
      placeholder: 'NIP',
    },
    email: {
      placeholder: 'Adres e-mail',
    },
  },
};
